import { FC } from 'react';

import { Rating as UIRating } from './rating.styles';

type Props = {
  value: number;
  color: string;
};

export const Rating: FC<Props> = ({ value, color }) => (
  <UIRating $color={color} component="span">
    {value}
  </UIRating>
);
